import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconLogic = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    "data-mntl-flip-svg": "true"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.624 18.532L5.257 14.98a.75.75 0 10-1.249.832l1.626 2.438H1.75V6.75H7a.75.75 0 100-1.5H1A.75.75 0 00.25 6v13c0 .414.336.75.75.75h4.564l-1.556 2.334a.75.75 0 101.249.832l2.23-3.346a.748.748 0 00.263-.59.749.749 0 00-.126-.448zM11 22.25a1.75 1.75 0 01-1.75-1.75v-4c0-.966.783-1.75 1.75-1.75h10c.966 0 1.75.784 1.75 1.75v4A1.75 1.75 0 0121 22.25H11zm-.25-1.75c0 .138.112.25.25.25h10a.25.25 0 00.25-.25v-4a.25.25 0 00-.25-.25H11a.25.25 0 00-.25.25v4zM11 9.75A1.75 1.75 0 019.25 8V4c0-.967.783-1.75 1.75-1.75h10c.966 0 1.75.783 1.75 1.75v4A1.75 1.75 0 0121 9.75H11zM10.75 8c0 .138.112.25.25.25h10a.25.25 0 00.25-.25V4a.25.25 0 00-.25-.25H11a.25.25 0 00-.25.25v4z",
      fill: color
    })
  }));
});
IconLogic.displayName = "IconLogic";

export { IconLogic };
